import { render, staticRenderFns } from "./car_Accident.vue?vue&type=template&id=3f094e83&scoped=true"
import script from "./car_Accident.vue?vue&type=script&lang=js"
export * from "./car_Accident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f094e83",
  null
  
)

export default component.exports